export const SET_RECENT_STUDENT = "SET_RECENT_STUDENT";

export const set_recent_student = (studentData) => {
  return {
    type: SET_RECENT_STUDENT,
    payload: studentData,
  };
};
